<template>
  <div class="contentBox">
    <div>
      <agricultural-services-left></agricultural-services-left>
      <agricultural-services-right ></agricultural-services-right>
    </div>
  </div>
</template>
<script>
import agriculturalServicesLeft from './agriculturalServices/agriculturalServicesLeft.vue'
import AgriculturalServicesRight from './agriculturalServices/agriculturalServicesRight.vue'
export default {
  components: { agriculturalServicesLeft, AgriculturalServicesRight },
    data() {
    return {
    }
  }

}
</script>
<style scoped>
  .contentBox{
    min-height: 400px;
  }
</style>
